<script>
import HeaderListCategory from "@/components/admin/category/HeaderListCategory.vue";
import ItemListCategory from "@/components/admin/category/ItemListCategory.vue";
import {api} from "@/modules/api";
import DrawerCategory from "@/components/admin/category/DrawerCategory.vue";
import BreadcrumpAdmin from "@/components/BreadcrumdAdmin.vue";

const headers = ['Nom', 'Nombre produit', 'Nb Produit hors stock']
export default {
  name: 'ListCategory',
  components: {BreadcrumpAdmin, DrawerCategory, ItemListCategory, HeaderListCategory},
  data () {
    return {
      headers,
      categories: {},
      search: null,
      filteredCategories: {},
      isOpen: false
    }
  },
  watch: {
    search(newSearch) {
      this.filteredCategories = this.categories.filter(category => {
        return category.label.toLowerCase().includes(newSearch.toLowerCase());
      })
    },
    categories(newCategories) {
      this.filteredCategories = newCategories
    }
  },
  async mounted() {
    await this.loadData()
    this.emitter.on('load-data', () => {
      this.loadData()
    })
    this.filteredCategories = this.categories
  },
  methods: {
    async loadData () {
      this.categories = await api.categories.get()
    }
  }
}
</script>

<template>
  <section class="">
    <div class="mx-auto max-w-screen-xl px-4 lg:px-12">
      <breadcrump-admin
          :second-items="{ text: `Catégories` }"
      />
      <div class="bg-white dark:bg-gray-800 relative shadow-md sm:rounded-lg overflow-hidden">
        <header-list-category v-model="search" @open-view="isOpen = true" />
        <div class="overflow-x-auto">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th
                  v-for="(item, index) in headers"
                  :key="index"
                  scope="col"
                  class="px-4 py-3"
              >
                {{ item }}
              </th>
              <th scope="col" class="px-4 py-3">
                <span class="sr-only">Actions</span>
              </th>
            </tr>
            </thead>
            <tbody>
              <item-list-category v-for="(category, index) in filteredCategories" :key="index" :category="category" />
            </tbody>
          </table>
        </div>
        <nav class="flex flex-col md:flex-row justify-between items-start md:items-center space-y-3 md:space-y-0 p-4" aria-label="Table navigation">
          <span class="text-sm font-normal text-gray-500 dark:text-gray-400">
            Total: {{ filteredCategories.length }}
          </span>
        </nav>
      </div>
    </div>
    <drawer-category v-if="isOpen" @close-view="isOpen = false" />
  </section>
</template>

<style scoped>

</style>